import { InjectionToken } from '@angular/core';

export interface IAppUpdate {
  appVersionCode: () => number;
  downloadAppUrl?: string;
  downloadAppFunc?: () => void;
}

export interface IPacificwiseAngularConfig extends Partial<IAppUpdate> {
  storage: () => Storage;
}

export const API_STORAGE = new InjectionToken<any>('PacificwiseAngularStorage');
export const APP_UPDATE = new InjectionToken<IAppUpdate>('PacificwiseAngularAppUpdate');
  